"use client";
import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

export const WrapperSuzuka2025 = (props: Props) => {
	return (
		<div className="relative min-h-screen bg-[#EBEBEB]">
			{/* 背景装飾 - ページ上部に配置（header領域を避ける） */}
			<div
				className="absolute left-0 right-0 pointer-events-none z-10"
				style={{ top: "-10vh" }}
			>
				<img
					src="/events/suzuka2025/back.png"
					alt=""
					className="absolute top-0 left-0 w-screen object-cover"
					style={{
						objectPosition: "center top",
						height: "max(800px, max(85vh, 85vw))",
						transformOrigin: "center top",
					}}
				/>
			</div>

			{/* コンテンツ */}
			<div className="relative z-10 flex justify-center">
				<div className="flex flex-col gap-20 my-8 w-full md:w-8/12 lg:w-8/12 max-w-[1200px]">
					{props.children}
				</div>
			</div>
		</div>
	);
};
